import { createSelector } from 'reselect'
import RequestStatus from 'constants/requestStatus'
import { SYSTEM_CONFIG_CODE } from 'constants/systemConfig'

export const getSystemConfigList = (state) =>
  state?.store?.systemConfig?.list || []

export const getPagination = (state) =>
  state.store?.systemConfig?.pagination || {}

export const moduleList = createSelector(
  [(state) => state?.store?.systemConfig?.modules],
  (modules = []) => modules.filter((module) => module.name !== 'portal')
)

export const defaultTimezone = (state) => {
  const configs = state?.store?.systemConfig?.systems || []
  const config = configs.find(
    (conf) => conf.code === SYSTEM_CONFIG_CODE.defaultTimezone
  )
  return config?.value || config?.defaultValue
}

export const defaultMaxFileSize = (state) => {
  const configs = state?.store?.systemConfig?.systems || []
  const config = configs.find(
    (conf) => conf.code === SYSTEM_CONFIG_CODE.maximumFileSize
  )
  return Number(config?.value || config?.defaultValue || 0)
}

export const systemConfigList = (state) =>
  state?.store?.systemConfig?.systems || []

export const getVehicleModelList = (state) =>
  state?.store?.systemConfig?.vehicleModels || []

export const isLoading = (state) =>
  state.requests?.systemConfig?.getSystemConfigs.status ===
  RequestStatus.STARTED

export const currentModule = (state) =>
  state?.store.systemConfig.currentModule || ''

export const adminPortalList = (state) =>
  state?.store?.systemConfig?.adminPortals || []
